import * as React from "react";
import Box from "@mui/material/Box";
const TabPanel = ({ value, index, children }) => {
    return (React.createElement("div", { role: "tabpanel", hidden: value !== index, id: `simple-tabpanel-${index}`, "aria-labelledby": `simple-tab-${index}` }, value === index && React.createElement(Box, { p: 3 }, children)));
};
export default TabPanel;
